import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Divider } from 'antd';
import { useGetAccountEntityDetails } from '../../../../queries/AccountEntity';
import { showErrorToast } from '../../../../services/notificationsService';
import { getDefaultRangePickerValue } from '../../../../utils';
import { ViewPanel } from '../../../../containers/view/ViewPanel';
import { ZorbaDateRangePicker } from '../../../../components/forms/ZorbaDateRangePicker';
import { BuyBoxCard } from './Components/BuyboxCard';
import { AccountTabs } from './Components/AccountTabs';
import { Header } from './Components/Header';
import { Overview } from './Components/Overview';
import { Transactions } from './Components/Transactions';

import './index.scss';

export const AccountDetails = () => {
  const { entityName } = useParams();
  const [activeTab, setActiveTab] = useState('1');
  const [selectedRange, setSelectedRange] = useState(
    getDefaultRangePickerValue(90),
  );
  const { appliedFilters } = useSelector(
    ({ FiltersReducer }) => FiltersReducer,
  );

  const {
    data: accountDetailsData,
    isLoading: isDetailsLoading,
    isError: isDetailsError,
  } = useGetAccountEntityDetails({
    selectedRange,
    entityName,
    appliedFilters,
  });

  if (isDetailsError) {
    showErrorToast('Fetching account details failed!');
  }

  const isMultiFamilySelected = appliedFilters?.propertyType?.isAnyOf?.includes(
    'Multi Family Home',
  );
  const isVacantSelected = appliedFilters?.propertyType?.isAnyOf?.includes(
    'Vacant',
  );

  const renderComponent = () => {
    switch (activeTab) {
      case '1':
        return (
          <Overview
            entityName={entityName}
            appliedFilters={appliedFilters}
            selectedRange={selectedRange}
            accountDetailsData={accountDetailsData}
            isDetailsLoading={isDetailsLoading}
          />
        );
      case '2':
        return <BuyBoxCard entityName={entityName} />;
      case '3':
        return (
          <Transactions
            isMultiFamilySelected={isMultiFamilySelected}
            isVacantSelected={isVacantSelected}
            appliedFilters={appliedFilters}
            selectedRange={selectedRange}
            entityName={entityName}
          />
        );

      default:
        return <div />;
    }
  };

  return (
    <div className="account-details">
      <div className="account-details-filter">
        <Header buyerName={entityName} />
        <AccountTabs
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          entityName={entityName}
        />
      </div>
      <Divider className="divider" />
      {(activeTab === '1' || activeTab === '3') && (
        <ViewPanel>
          <ZorbaDateRangePicker
            onChange={(e) => setSelectedRange(e)}
            value={selectedRange}
            rangePresets={[
              { label: 'Last 30 days', value: 30 },
              { label: 'Last 60 days', value: 60 },
              { label: 'Last 90 days', value: 90 },
            ]}
            disabled={isDetailsLoading}
          />
        </ViewPanel>
      )}
      {renderComponent()}
    </div>
  );
};
